
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateGroupChatDtoFormGroup() {
return new FormGroup({
    title: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    userIds: new FormControl<Array<number> | undefined>([], [Validators.required]),
})
;
}
      